import { render, staticRenderFns } from "./BgArea.vue?vue&type=template&id=b66c0356&"
import script from "./BgArea.vue?vue&type=script&lang=js&"
export * from "./BgArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports